<template>
    <div class="md-layout">
        <div class="md-layout-item md-size-100">
            <md-card class="pl-1 pr-1">
                <md-card-header class="pb-0">
                    <h4 class="title pt-1">Pesquisar</h4>
                </md-card-header>
                <md-card-content class="pt-2 pb-2">
                    <div class="md-layout">
                        <div
                            class="md-layout-item md-size-20 md-small-size-100"
                        >
                            <md-field>
                                <label>Cluster</label>
                                <md-input
                                    type="text"
                                    v-model="filterCluster"
                                ></md-input>
                            </md-field>
                        </div>
                        <div
                            class="md-layout-item md-size-20 md-small-size-100"
                        >
                            <md-field>
                                <label>CD</label>
                                <md-input
                                    type="text"
                                    v-model="filterDC"
                                ></md-input>
                            </md-field>
                        </div>
                        <div
                            class="md-layout-item md-size-20 md-small-size-100"
                        >
                            <md-field>
                                <label>Estado</label>
                                <md-input
                                    type="text"
                                    v-model="filterState"
                                ></md-input>
                            </md-field>
                        </div>
                        <div
                            class="md-layout-item md-size-20 md-small-size-100"
                        >
                            <md-field>
                                <label>Cidade</label>
                                <md-input
                                    type="text"
                                    v-model="filterCity"
                                ></md-input>
                            </md-field>
                        </div>
                        <div
                            class="md-layout-item md-size-20 md-small-size-100"
                        >
                            <md-field>
                                <label>Loja</label>
                                <md-input
                                    type="text"
                                    v-model="filterBranch"
                                ></md-input>
                            </md-field>
                        </div>
                        <div class="md-layout-item md-size-100 text-right mt-1">
                            <md-button
                                class="md-danger md-sm ml-1"
                                @click="clearFilter()"
                            >
                                Limpar
                            </md-button>
                            <md-button
                                class="md-primary md-sm ml-1"
                                @click="applyFilter()"
                                :disabled="loading"
                            >
                                Pesquisar
                            </md-button>
                        </div>
                    </div>
                </md-card-content>
            </md-card>
        </div>
        <div class="md-layout-item md-size-100">
            <md-card>
                <md-card-header class="md-card-header-icon md-card-header-blue">
                    <div class="card-icon">
                        <md-icon>people</md-icon>
                    </div>
                    <h4 class="title"></h4>
                </md-card-header>
                <md-card-content>
                    <md-table
                        :value="queriedData.results"
                        :md-sort.sync="currentSort"
                        :md-sort-order.sync="currentSortOrder"
                        :md-sort-fn="customSort"
                        @md-selected="onSelectRelationship"
                        class="table-hover"
                    >
                        <md-table-toolbar>
                            <div class="md-toolbar-section-start">
                                <h1 class="md-title">Filias Filtradas</h1>
                                <md-button
                                    class="md-primary md-sm"
                                    @click.native="editOpen()"
                                >
                                    Adicionar
                                </md-button>
                                <md-button
                                    class="md-just-icon md-simple"
                                    @click.native="handleColumnsEdit()"
                                >
                                    <md-icon>settings</md-icon>
                                </md-button>
                            </div>
                        </md-table-toolbar>

                        <md-table-toolbar
                            class="mt-2"
                            slot="md-table-alternate-header"
                            slot-scope="{}"
                        >
                            <div class="md-toolbar-section-start">
                                <md-button
                                    class="md-simple md-primary"
                                    @click="editRelationship()"
                                >
                                    <i class="fa fa-retweet"></i>
                                    Editar Relacionamento
                                </md-button>
                            </div>
                        </md-table-toolbar>
                        <md-table-row
                            slot="md-table-row"
                            slot-scope="{ item }"
                            md-selectable="multiple"
                            md-auto-select
                            @mouseenter="actionVisible = item.id"
                            @mouseleave="actionVisible = null"
                        >
                            <md-table-cell
                                v-for="column in visibleColumns"
                                :md-label="columnNames[column]"
                                :md-sort-by="column"
                                :key="column"
                                :title="item[column]"
                            >
                                {{
                                    column == 'type'
                                        ? branchTypes[item[column]]
                                        : column == 'channel'
                                        ? branchChannels[item[column]]
                                        : item[column]
                                }}
                            </md-table-cell>
                            <div class="action-cell">
                                <div v-if="actionVisible == item.id">
                                    <md-button
                                        class="md-just-icon md-primary md-simple m-0"
                                        style="width: 2.5rem"
                                        @click="editAmplitude(item)"
                                    >
                                        <i class="fas fa-box"></i>
                                    </md-button>
                                    <md-button
                                        class="md-just-icon md-primary md-simple m-0"
                                        style="width: 2.5rem"
                                        @click="editRelationship(item)"
                                    >
                                        <i class="fa fa-retweet"></i>
                                    </md-button>
                                    <md-button
                                        class="md-just-icon md-primary md-simple m-0"
                                        style="width: 2.5rem"
                                        @click="viewOpen(item)"
                                    >
                                        <md-icon>open_in_browser</md-icon>
                                    </md-button>
                                    <md-button
                                        class="md-just-icon md-warning md-simple m-0"
                                        style="width: 2.5rem"
                                        @click="editOpen(item)"
                                    >
                                        <md-icon>edit</md-icon>
                                    </md-button>
                                    <md-button
                                        class="md-just-icon md-danger md-simple m-0"
                                        style="width: 2.5rem"
                                        @click.native="handleDelete(item)"
                                    >
                                        <md-icon>close</md-icon>
                                    </md-button>
                                </div>
                            </div>
                        </md-table-row>
                    </md-table>
                </md-card-content>
                <md-card-actions md-alignment="space-between">
                    <div class="">
                        <p class="card-category">
                            Mostrando <select id="numberItemPage" v-model="pagination.perPage">
                                <option value=20 selected>20</option>
                                <option value=40>40</option>
                                <option value=60>60</option>
                                <option value=80>80</option>
                                <option value=100>100</option>
                            </select> itens de um total de {{ total }}.                            
                        </p>
                    </div>
                    <pagination
                        class="pagination-no-border pagination-success"
                        v-model="pagination.currentPage"
                        :per-page="pagination.perPage"
                        :total="total"
                    >
                    </pagination>
                </md-card-actions>
            </md-card>
        </div>

        <modal v-if="viewModal" @close="viewCancel()">
            <template slot="header">
                <h4 class="modal-title">Detalhes</h4>
                <md-button
                    class="md-simple md-just-icon md-round modal-default-button"
                    @click="viewCancel()"
                >
                    <md-icon>clear</md-icon>
                </md-button>
            </template>

            <template slot="body">
                <div class="md-layout">
                    <div
                        class="md-layout-item md-small-size-100 md-size-100"
                        v-for="field in Object.keys(showColumns)"
                        :key="field"
                    >
                        <b>{{ columnNames[field] }}:</b>
                        {{
                            field == 'type'
                                ? branchTypes[editModalModel[field]]
                                : field == 'channel'
                                ? branchChannels[editModalModel[field]]
                                : editModalModel[field]
                        }}
                    </div>
                </div>
            </template>

            <template slot="footer">
                <md-button class="md-simple" @click="viewCancel()">
                    Fechar
                </md-button>
            </template>
        </modal>

        <form @submit.prevent="editSubmit()">
            <modal v-if="editModal" @close="editCancel()">
                <template slot="header">
                    <h4 class="modal-title">{{ editModalTitle }}</h4>
                    <md-button
                        class="md-simple md-just-icon md-round modal-default-button"
                        @click="editCancel()"
                    >
                        <md-icon>clear</md-icon>
                    </md-button>
                </template>

                <template slot="body">
                    <div class="md-layout">
                        <div
                            class="md-layout-item md-small-size-100 md-size-100"
                            v-for="field in editableFields"
                            :key="field"
                        >
                            <md-field
                                v-if="fieldTypes[field] != 'datetime-local'"
                            >
                                <label>{{ columnNames[field] }}</label>
                                <md-select
                                    v-if="field == 'type'"
                                    v-model="editModalModel[field]"
                                >
                                    <md-option
                                        v-for="type in Object.keys(branchTypes)"
                                        v-bind:key="`type-${type}`"
                                        :value="type"
                                    >
                                        {{ branchTypes[type] }}
                                    </md-option>
                                </md-select>
                                <md-select
                                    v-else-if="field == 'channel'"
                                    v-model="editModalModel[field]"
                                >
                                    <md-option
                                        v-for="channel in Object.keys(
                                            branchChannels
                                        )"
                                        v-bind:key="`channel-${channel}`"
                                        :value="channel"
                                    >
                                        {{ branchChannels[channel] }}
                                    </md-option>
                                </md-select>
                                <md-input
                                    v-else
                                    v-model="editModalModel[field]"
                                    :type="fieldTypes[field]"
                                ></md-input>
                            </md-field>
                            <md-datepicker
                                v-model="editModalModel[field]"
                                v-else
                                md-immediately
                            >
                                <label>{{ columnNames[field] }}</label>
                            </md-datepicker>
                        </div>
                        <div
                            class="md-layout-item md-small-size-100 md-size-100"
                            style="overflow-x: visible; margin-bottom: 7px;"
                        >
                            <label class="artificial-label">
                                Cluster
                            </label>
                            <vue-simple-suggest
                                v-model="clusterModel"
                                :list="clusterList"
                                :debounce="500"
                                display-attribute="name"
                                value-attribute="id"
                                @select="clusterSelected"
                            >
                            </vue-simple-suggest>
                        </div>
                    </div>
                </template>

                <template slot="footer">
                    <md-button class="md-simple" @click="editCancel()">
                        Cancelar
                    </md-button>
                    <md-button class="md-primary" type="submit">
                        Salvar
                    </md-button>
                </template>
            </modal>
        </form>

        <modal v-if="columnsModal" @close="columnsCancel()" width="250px">
            <template slot="header">
                <h4 class="modal-title">Colunas disponíveis</h4>
                <md-button
                    class="md-simple md-just-icon md-round modal-default-button"
                    @click="columnsCancel()"
                >
                    <md-icon>clear</md-icon>
                </md-button>
            </template>

            <template slot="body">
                <div style="text-align: left">
                    <md-checkbox
                        v-for="column in Object.keys(showColumns)"
                        v-model="showColumns[column]"
                        :key="column"
                    >
                        {{ columnNames[column] }}
                    </md-checkbox>
                </div>
            </template>

            <template slot="footer">
                <md-button class="md-primary" @click="columnsCancel()">
                    OK
                </md-button>
            </template>
        </modal>
    </div>
</template>

<script>
import { Pagination, Modal } from '@/components'
import Swal from 'sweetalert2'
import VueSimpleSuggest from 'vue-simple-suggest'
import { mapState, mapActions } from 'vuex'

import { ClusterService } from '@/services/cluster.service'
import { Branch as Model } from '@/models/branch.model'
const model = 'branches'

export default {
    created() {
        this.readEntities()
    },
    components: {
        Pagination,
        VueSimpleSuggest,
        Modal
    },
    computed: {
        ...mapState({
            queriedData: state => state[model].page
        }),
        total() {
            return this.queriedData.count
        },
        visibleColumns() {
            let columns = []
            Object.keys(this.showColumns).forEach(key => {
                if (this.showColumns[key]) columns.push(key)
            })
            return columns
        }
    },
    data() {
        return {
            loading: false,
            viewModal: false,
            editModalTitle: '',
            editModalModel: new Model(),
            editModal: false,
            columnsModal: false,
            showColumns: Model.visibleFields,
            columnNames: Model.fieldNames,
            editableFields: Object.keys(Model.editableFields).filter(
                item => ['ranking_cluster'].indexOf(item) == -1
            ),
            fieldTypes: Model.fieldTypes,
            currentSort: 'id',
            currentSortOrder: 'asc',
            pagination: {
                perPage: 20,
                currentPage: 1,
                total: 0
            },

            filterCluster: null,
            filterDC: null,
            filterState: null,
            filterCity: null,
            filterBranch: null,

            branchTypes: {
                S: 'Loja',
                D: 'CD'
            },
            branchChannels: {
                R: 'Varejo',
                W: 'Atacado'
            },
            actionVisible: null,
            selectedItems: [],

            clusterModel: null
        }
    },
    methods: {
        ...mapActions(model, {
            createEntity: 'create',
            _readEntities: 'read',
            updateEntity: 'update',
            deleteEntity: 'delete',
            selectItems: 'selectItems'
        }),
        async readEntities(args) {
            if (!args) args = {}
            this.loading = true
            await this._readEntities(args)
            this.loading = false
        },
        customSort(value) {
            return value.sort((a, b) => {
                const sortBy = this.currentSort
                try {
                    if (this.currentSortOrder === 'desc')
                        return a[sortBy].localeCompare(b[sortBy])
                    return b[sortBy].localeCompare(a[sortBy])
                } catch (e) {
                    return 0
                }
            })
        },
        handleColumnsEdit() {
            this.columnsModal = true
        },
        columnsCancel() {
            this.columnsModal = false
        },

        viewOpen(item) {
            this.editModalModel = { ...this.editModalModel, ...item }
            this.viewModal = true
        },
        viewCancel() {
            this.viewModal = false
            this.editModalModel = new Model()
        },

        editOpen(item) {
            if (item) {
                this.editModalTitle = 'Editando #' + item.id

                this.editModalModel = { ...this.editModalModel, ...item } // copy object values
                this.clusterUpdate()
            } else {
                this.editModalTitle = 'Nova filial'
            }
            this.editModal = true
        },
        editCancel() {
            this.editModal = false
            this.editModalModel = new Model()
        },
        async editSubmit() {
            let editError

            if (this.editModalModel.id) {
                editError = await this.updateEntity({
                    ...this.editModalModel
                })
            } else {
                editError = await this.createEntity({
                    ...this.editModalModel
                })
            }

            if (editError)
                this.$notify({
                    message:
                        'Erro ao ' +
                        (this.editModalModel.id ? 'editar' : 'criar') +
                        ' filial.',
                    icon: 'add_alert',
                    horizontalAlign: 'right',
                    verticalAlign: 'bottom',
                    type: 'danger'
                })
            else {
                this.$notify({
                    message:
                        'Filial ' +
                        (this.editModalModel.id ? 'editada' : 'criada') +
                        ' com sucesso!',
                    icon: 'add_alert',
                    horizontalAlign: 'right',
                    verticalAlign: 'bottom',
                    type: 'success'
                })

                this.editModal = false
                this.editModalModel = new Model()
                this.readEntities()
            }
        },

        handleDelete(item) {
            Swal.fire({
                title: 'Certeza?',
                text: 'Esta ação é irreversível.',
                type: 'warning',
                showCancelButton: true,
                confirmButtonClass: 'md-button md-danger btn-fill',
                cancelButtonClass: 'md-button md-simple',
                confirmButtonText: 'Sim, remover!',
                cancelButtonText: 'Cancelar',
                buttonsStyling: false
            }).then(async result => {
                if (result.value) {
                    let deleteError = await this.deleteEntity({ id: item.id })

                    if (deleteError)
                        this.$notify({
                            message: 'Erro ao remover.',
                            icon: 'add_alert',
                            horizontalAlign: 'right',
                            verticalAlign: 'bottom',
                            type: 'danger'
                        })
                    else {
                        this.$notify({
                            message: 'Removido com sucesso!',
                            icon: 'add_alert',
                            horizontalAlign: 'right',
                            verticalAlign: 'bottom',
                            type: 'success'
                        })
                        this.readEntities()
                    }
                }
            })
        },

        clearFilter() {
            this.filterCluster = null
            this.filterDC = null
            this.filterState = null
            this.filterCity = null
            this.filterBranch = null
            this.readEntities()
        },
        applyFilter() {
            this.pagination.currentPage = 1
            this.readEntities({
                cluster: this.filterCluster,
                dc: this.filterDC,
                state: this.filterState,
                city: this.filterCity,
                branch: this.filterBranch,
                page: 1,
                limit: this.pagination.perPage
            })
        },

        onSelectRelationship(items) {
            this.selectedItems = items
        },

        editRelationship(item) {
            if (item) {
                this.selectItems([item])
            } else {
                this.selectItems(this.selectedItems)
            }

            this.$router.push('/branches-relationship')
        },

        editAmplitude(item) {
            this.selectItems([item])
            this.$router.push('/restocking-amplitude')
        },

        async clusterList() {
            let clusters = await ClusterService.read({
                q: this.clusterModel
            })
                .then(res => res.data)
                .then(json => json.results)
            clusters = clusters.map(item => {
                if (item.external_id)
                    item.name = item.external_id + ' - ' + item.name
                return item
            })
            return clusters
        },
        async clusterUpdate() {
            if (!this.editModalModel.ranking_cluster) {
                this.clusterModel = null
                return
            }
            let cluster = await ClusterService.read(
                this.editModalModel.ranking_cluster
            ).then(res => res.data)
            this.clusterModel = cluster.name
            if (cluster.external_id)
                this.clusterModel =
                    cluster.external_id + ' - ' + this.clusterModel
        },
        clusterSelected(selectedItem) {
            this.editModalModel['ranking_cluster'] = selectedItem.id
        }
    },
    watch: {
        pagination: {
            handler: function(val) {
                if (val.perPage) val.perPage = parseInt(val.perPage)
                this.readEntities({ 
                    cluster: this.filterCluster,
                    dc: this.filterDC,
                    state: this.filterState,
                    city: this.filterCity,
                    branch: this.filterBranch,
                    page: val.currentPage,
                    limit: this.pagination.perPage
                })
            },
            deep: true
        }
    }
}
</script>

<style>
.vue-simple-suggest.designed .input-wrapper input {
    border-radius: 0 !important;
    padding: 7px 0 !important;
    font-size: 14px !important;
    font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif !important;
    -webkit-text-fill-color: #3c4858 !important;
    border: none !important;
    border-bottom: 1px solid #ccc !important;
}
.vue-simple-suggest.designed .input-wrapper input:focus {
    border: none !important;
    border-bottom: 2px solid #448aff !important;
}
</style>
<style lang="css" scoped>
.artificial-label {
    color: #aaaaaa !important;
    font-weight: 400;
    font-size: 0.6875rem;
    line-height: 1.4;
}
.md-card .md-card-actions {
    border: 0;
    margin-left: 20px;
    margin-right: 20px;
}
.modal-wrapper .md-checkbox {
    display: flex !important;
}
.md-table + .md-table {
    margin-top: 16px;
}
.md-table .md-table-head-label {
    padding-right: 30px !important;
}
.md-table-sortable-icon {
    left: auto !important;
    right: 0px !important;
}
.paginated-table .md-table-toolbar {
    padding-left: 2rem !important;
    padding-right: 2rem !important;
}
.action-cell {
    position: absolute;
    left: auto;
    right: 21px;
    height: 48px;
    background: rgb(255, 255, 255);
    background: linear-gradient(
        90deg,
        rgba(255, 255, 255, 0) 0%,
        rgba(255, 255, 255, 0.8) 11%,
        rgba(255, 255, 255, 0.8) 100%
    );
}
.action-cell div {
    height: 100%;
    text-align: right;
    padding-left: 2rem;
    padding-right: 1rem;
}
</style>
